namespace TabAurous.Finance {
    export interface PeriodicClosingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        PostingDate?: string;
        VoucherNo?: string;
        FinancialYear?: number;
        CompanyId?: number;
        SurplusAccountId?: number;
    }

    export namespace PeriodicClosingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PeriodicClosing';
        export const deletePermission = 'Finance:PeriodicClosing:Delete';
        export const insertPermission = 'Finance:PeriodicClosing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:PeriodicClosing:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            PostingDate = "PostingDate",
            VoucherNo = "VoucherNo",
            FinancialYear = "FinancialYear",
            CompanyId = "CompanyId",
            SurplusAccountId = "SurplusAccountId"
        }
    }
}
